import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const TikTok = asyncComponent({
    resolve: () => import('./TikTok'),
});

export default class TikTokWrapper extends Component {
    render() {
        return(
            <div>
                <TikTok config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.id)} />
            </div>
        );
    }
}

TikTokWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
